import { Factory, Warehouse, Laptop, FileText, Users, Calculator, ShoppingCart, Megaphone, Headphones, Truck, HardHat, HeartPulse, Briefcase, Shapes, UserX, Tag } from "lucide-react";

const MAP = [
  [/v[ýy]rob/i, Factory, "text-emerald-600 bg-emerald-50"],
  [/logist|sklad/i, Warehouse, "text-orange-600 bg-orange-50"],
  [/\bit\b|technol/i, Laptop, "text-blue-600 bg-blue-50"],
  [/hr|personal/i, Users, "text-fuchsia-600 bg-fuchsia-50"],
  [/admin/i, FileText, "text-violet-600 bg-violet-50"],
  [/financ|[úu][čc]tov/i, Calculator, "text-sky-600 bg-sky-50"],
  [/obchod|predaj/i, ShoppingCart, "text-amber-600 bg-amber-50"],
  [/marketing/i, Megaphone, "text-pink-600 bg-pink-50"],
  [/z[áa]kazn/i, Headphones, "text-cyan-600 bg-cyan-50"],
  [/doprav/i, Truck, "text-lime-700 bg-lime-50"],
  [/stav|techn/i, HardHat, "text-yellow-700 bg-yellow-50"],
  [/zdrav/i, HeartPulse, "text-rose-600 bg-rose-50"],
  [/mana/i, Briefcase, "text-indigo-600 bg-indigo-50"],
  [/ostatn/i, Shapes, "text-slate-600 bg-slate-100"],
  [/nezaraden/i, UserX, "text-slate-500 bg-slate-100"],
];

export const areaStyle = (name) => {
  const m = MAP.find(([re]) => re.test(name || ""));
  return m ? { Icon: m[1], cls: m[2] } : { Icon: Tag, cls: "text-violet-600 bg-violet-50" };
};

export function AreaBadge({ name }) {
  const { cls } = areaStyle(name);
  return <span className={`inline-flex max-w-full truncate rounded-md px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{name}</span>;
}
